export function objToStrMap<T>(obj: { [x: string]: T }) {
  let strMap = new Map<string, T>();
  for (let k of Object.keys(obj)) {
    strMap.set(k, obj[k]);
  }
  return strMap;
}
